//import {getToken} from "../Utils/Common";
//import axios from "axios";
//import {getUserInfo} from "./user";

import {getOut, getToken} from "../Utils/Common";
import {getUserInfo} from "./user";

//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"
let apilink = process.env.REACT_APP_BACKEND_API_URI


export async function lvUploadAPI(data, projectName, filename) {
	
	//PaaS :: Create Project
	//getuserdata-todo//
	let userData = await getUserInfo();

	///send email///
    // let emaildetails = {
    //     user_name : userData.fn + " " + userData.ln,
    //     proj_name : projectName,
    //     purpose : "lvupload"
    // }
    //await sendEmail(userData.em,emaildetails)



	// let userID = userData.uid
	// let companyName = userData.cm
	// companyName = companyName.replaceAll(' ', '_')
	///////////////
	//let userID = "TestUserId"
	//let companyName = "TestUserCM"
	//let firstName = "TestFName"
	//let lastName = "TestLname"
	//companyName = companyName.replaceAll(' ', '_')
	projectName = projectName.replaceAll(' ', '_')
	// let paasURL = `${process.env.REACT_APP_PAAS_PROJECT_BASE_URI}` + '?userID=' + userID + '&companyName=' + companyName
	// 	+ '&projectName=' + projectName + '&filename=' + filename

	data.append('userID', userData.uid);
	data.append('companyName', userData.company);
	data.append('projectName', projectName);
	data.append('filename', filename);
	data.append('firstName', userData.fn);
	data.append('lastName', userData.ln);



	////////create project//////////
	let url = apilink + "projects/createproject"
	let f = JSON.stringify({"lvdata":Object.fromEntries(data),
        "token":getToken(),
})
	let platformResponse = await fetch(url, {
		method: "POST",
		 headers: {
		 	//'Authorization': getToken(),
		 	"Content-Type": "application/json"
		},
		body: f
	}).then(data => data.json())
	////////////////////////////////

	// await fetch(paasURL).then(r => r)
	//
	// let platformResponse = axios.post(`${process.env.REACT_APP_BASE_URI}/api/projects/v1/resources/uploadlv`, data, {
	// 	headers: {
	// 		'Content-Type': 'multipart/form-data',
	// 		'Authorization': 'Bearer ' + getToken()
	// 	}
	// })
	//return (await platformResponse).status

    if (platformResponse.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
			getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
		}

		///send email///
     // let emaildetails = {
     //     user_name : userData.fn + " " + userData.ln,
     //     proj_name : projectName,
     //     purpose : "lvupload"
     // }

	return platformResponse.status
}


//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"


export async function lvUploadAPIFromMaterial(data, projectName, filename) {

    let userID = "TestUserId"
    let companyName = "TestUserCM"
    let firstName = "TestFName"
    let lastName = "TestLname"
    companyName = companyName.replaceAll(' ', '_')
    projectName = projectName.replaceAll(' ', '_')

    data.append('userID', userID);
    data.append('companyName', companyName);
    data.append('projectName', projectName);
    data.append('filename', filename);
    data.append('firstName', firstName);
    data.append('lastName', lastName);

    let url = apilink + "projects/createproject"
    let f = JSON.stringify({"lvdata": Object.fromEntries(data)})
    let platformResponse = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: f
    }).then(data => data.json())

    if (platformResponse.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
			getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`)
		}

    return platformResponse.status

}